
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/privacy",
      function () {
        return require("private-next-pages/company/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/privacy"])
      });
    }
  